import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie-consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (choice: "accepted" | "rejected") => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      dir="rtl"
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 bg-background/95 backdrop-blur-md border-t border-border shadow-2xl animate-in slide-in-from-bottom duration-500"
      role="dialog"
      aria-label="באנר אישור עוגיות"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-6 w-6 text-primary shrink-0 mt-1" aria-hidden="true" />
          <div className="text-sm md:text-base text-foreground text-right">
            <p className="font-semibold mb-1">אנו משתמשים בעוגיות 🍪</p>
            <p className="text-muted-foreground">
              האתר משתמש בעוגיות כדי לשפר את חוויית הגלישה שלך. למידע נוסף, עיין ב
              <Link to="/privacy-policy" className="text-primary hover:underline mx-1 font-medium">
                מדיניות הפרטיות
              </Link>
              שלנו.
            </p>
          </div>
        </div>
        <div className="flex flex-row-reverse gap-2 w-full md:w-auto shrink-0">
          <Button
            onClick={() => handleChoice("accepted")}
            variant="default"
            size="sm"
            className="flex-1 md:flex-none"
          >
            אישור
          </Button>
          <Button
            onClick={() => handleChoice("rejected")}
            variant="outline"
            size="sm"
            className="flex-1 md:flex-none"
          >
            דחייה
          </Button>
          <Button
            onClick={() => handleChoice("rejected")}
            variant="ghost"
            size="icon"
            aria-label="סגור"
            className="hidden md:inline-flex"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
